import { apiSlice } from "../../apiSlice";
export const teincomeApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getDataGraphicTeincome: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Teincome`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    getDataGroupsTeincome: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Teincome/getDataGroups`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    generateExcelTeincome: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Teincome/generateExcel`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
  }),
});

export const { useGetDataGraphicTeincomeMutation, useGetDataGroupsTeincomeMutation, useGenerateExcelTeincomeMutation } =
  teincomeApiSlice;
